/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
import React from "react";
import { Checkbox } from "antd";
import ModuleHeader from "./ModuleHeader";
import { requestPermissions } from "./data";
import PermissionTitle from "./PermissionTitle";
import { PERMISSIONS } from "../../Login/constants";
import RequestIcon from "../../../Common/Svgs/RequestIcon";

const CONDITIONS = {
  VIEW_AND_EDIT: [PERMISSIONS.REQUEST_VIEW, PERMISSIONS.REQUEST_NO_ACCESS],
  REMOVE_ALL: [
    PERMISSIONS.REQUEST_VIEW_AND_EDIT,
    PERMISSIONS.REQUEST_VIEW,
    PERMISSIONS.REQUEST_NO_ACCESS,
  ],
};

const RequestPermissions = ({ permissions, setPermissions }) => {
  const handleModulePermission = (permissionId) => {
    let local = [];

    if (permissionId === PERMISSIONS.REQUEST_VIEW_AND_EDIT) {
      local = permissions.filter(
        (item) => !CONDITIONS.VIEW_AND_EDIT.includes(item),
      );
    }

    // removing all the location permissions
    if (permissionId === PERMISSIONS.REQUEST_VIEW) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    // removing all the location permissions
    if (permissionId === PERMISSIONS.REQUEST_NO_ACCESS) {
      local = permissions.filter(
        (item) => !CONDITIONS.REMOVE_ALL.includes(item),
      );
    }

    setPermissions([...local, permissionId]);
  };

  return (
    <div>
      <ModuleHeader
        module="Requests"
        icon={<RequestIcon size={16} className="text-primary" />}
      />
      {/* main module permission */}
      <div className="w-full h-[60px]">
        <div
          className="flex items-center w-full h-full border-b"
          style={{
            background: "#FAF2D8",
            borderColor: "#FAD152",
          }}
        >
          <div
            className="w-[40%] border-r py-3 px-6"
            style={{
              borderColor: "#FAD152",
            }}
          >
            <PermissionTitle
              title={requestPermissions[0].title}
              description={requestPermissions[0].description}
            />
          </div>

          <div className="w-[60%] h-full flex items-center">
            {requestPermissions[0].options.map((option, idx) => {
              // rendering empty div for layout consistency
              if (!option) {
                return (
                  <div
                    key={idx}
                    className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                    style={{
                      borderColor: "#FAD152",
                    }}
                  />
                );
              }

              const selected = permissions.includes(option.permissionId);

              return (
                <div
                  key={option.text}
                  className="w-[25%] border-r px-6 h-full flex items-center gap-x-2"
                  style={{
                    borderColor: "#FAD152",
                  }}
                >
                  <Checkbox
                    checked={selected}
                    onClick={() => handleModulePermission(option.permissionId)}
                  />
                  <p
                    className={`font-poppins text-xs ${
                      selected ? "font-medium" : "font-normal"
                    }`}
                  >
                    {option.text}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestPermissions;
